// extracted by mini-css-extract-plugin
export default {"linkedInLogo":"logo_linkedInLogo__Yk3qI"};